import React, { useState } from 'react';
import Modal, { ModalTitle, ModalActions } from '../../components/Modal/Modal';
import { PortalField } from '../../components/FormField/PortalField';
import { PortalInput } from '../../components/FormField/PortalInput';
import Button from '../../components/Button/Button';
import styles from './Pets.module.scss';

interface TransferToAdopterModalProps {
  open: boolean;
  onClose: () => void;
  moduleId: string;
  petId: string;
  onTransfer: (petId: string, firstName: string, lastName: string, email: string, phone: string) => void;
}

export default function TransferToAdopterModal({
  open,
  onClose,
  moduleId,
  petId,
  onTransfer,
}: TransferToAdopterModalProps) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  function handleClose() {
    setFirstName('');
    setLastName('');
    setEmail('');
    setPhone('');
    onClose();
  }

  function handleConfirm() {
    if (!firstName.trim() || !email.trim() || !phone.trim()) {
      return;
    }
    onTransfer(petId, firstName.trim(), lastName.trim(), email.trim(), phone.trim());
    handleClose();
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalTitle>Transfer to adopter</ModalTitle>
      <p className={styles.modalDescription}>
        Transfer <strong>{moduleId}</strong> to the adopter. The adopter will receive an email to set up their own Fi
        subscription.
      </p>

      <PortalField label="Adopter name">
        <div className={styles.fieldRow}>
          <PortalInput value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="First name" />
          <PortalInput value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Last name" />
        </div>
      </PortalField>

      <PortalField label="Adopter email">
        <PortalInput
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="e.g. sarah@gmail.com"
        />
      </PortalField>

      <PortalField label="Adopter phone">
        <PortalInput
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="e.g. (555) 555-0100"
        />
      </PortalField>

      <ModalActions>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="green" onClick={handleConfirm} disabled={!firstName.trim() || !email.trim() || !phone.trim()}>
          Transfer to Adopter
        </Button>
      </ModalActions>
    </Modal>
  );
}
